import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { createAppConfig } from './app/app.config';
import { initSentry } from './sentry';
import type { AppConfig } from '@shared/interfaces/app-config';

if (environment.production) {
  enableProdMode();
}

fetch(environment.configFile ?? 'assets/config-dev.json')
  .then((response): Promise<AppConfig> => response.json())
  .then((config) => {
    initSentry(config);
    void bootstrapApplication(App, createAppConfig(config));
  });
